import React from 'react';
import { POPUP_MESSAGES } from '../constants';
import { PopupMessageProps, PopupMessageConfig } from '../types';
import { XMarkIcon } from '@heroicons/react/24/solid';
import clsx from 'clsx';

const PopupMessage: React.FC<PopupMessageProps> = ({
  isAuthenticated,
  restrictBrowseAll,
  isTrial,
  onClose,
  contentClass,
}) => {
  const getMessageConfig = (): PopupMessageConfig | null => {
    if (!isAuthenticated) return POPUP_MESSAGES.UNAUTHENTICATED;
    if (restrictBrowseAll) return POPUP_MESSAGES.RESTRICTED_BROWSE;
    if (isTrial) return POPUP_MESSAGES.TRIAL;
    return null;
  };

  const messageConfig = getMessageConfig();
  if (!messageConfig) return null;

  return (
    <div className="popup-overlay">
      <div className={clsx('popup-content', contentClass)}>
        <div className="flex justify-between mb-4">
          <h3 className="ml-2">Register to view more</h3>
          <button onClick={onClose} className="mb-3">
            <XMarkIcon className="h-5 w-5 text-black" />
          </button>
        </div>
        <div>
          <p className="text-center text-base">
            {messageConfig.text}{' '}
            <a href={messageConfig.linkUrl} style={{ color: '#D02591' }}>
              {messageConfig.linkText}
            </a>
            {messageConfig.additionalText && (
              <>
                {' '}
                {messageConfig.additionalText}{' '}
                <a href={messageConfig.additionalLinkUrl} style={{ color: '#D02591' }}>
                  {messageConfig.additionalLinkText}
                </a>
                .
              </>
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PopupMessage;
